var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainPasswordBlue = function SvgMainPasswordBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10.3 12.4",
    style: {
      enableBackground: "new 0 0 10.3 12.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.1,4.9H3V2.8C3,1.8,4,1,5.1,1c1.2,0,2.1,0.8,2.1,1.9v1c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1 C8.3,1.3,6.9,0,5.1,0S2,1.3,2,2.8v2.1H1.2C0.5,4.9,0,5.4,0,6v5.4c0,0.6,0.5,1.1,1.2,1.1h7.9c0.7,0,1.2-0.5,1.2-1.1V6 C10.3,5.4,9.8,4.9,9.1,4.9z M9.2,6v5.4c0,0-0.1,0.1-0.1,0.1H1.2c-0.1,0-0.1,0-0.1-0.1V6c0,0,0.1-0.1,0.1-0.1h7.9 C9.2,5.9,9.2,5.9,9.2,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.9,6.4C4,6.4,3.3,7,3.3,7.7c0,0.4,0.2,0.7,0.4,0.9v1c0,0.6,0.5,1,1.2,1c0.7,0,1.2-0.5,1.2-1v-1 c0.3-0.3,0.5-0.6,0.5-0.9C6.6,7,5.8,6.4,4.9,6.4z M5,8.6l0,1.1c0,0,0,0-0.1,0s-0.1,0-0.1,0V8.6c0-0.2-0.1-0.4-0.3-0.6 C4.5,8,4.4,7.9,4.4,7.7c0-0.2,0.2-0.4,0.5-0.4s0.5,0.2,0.5,0.4C5.5,7.9,5.4,8,5.3,8C5.1,8.1,5,8.4,5,8.6z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainPasswordBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main_password_blue.3bb5a855.svg";
export { ForwardRef as ReactComponent };